module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-3d-998404de32cce5142da0e9080fd2466a.svg";